import { type TooltipPlacement } from "antd/lib/tooltip";
import { PureComponent } from "react";

import { IconInfoCircle } from "@btnet/blueprint-icons";
import { BTStatusBadge } from "@btnet/core-components";
import { BTPopover } from "@btnet/core-components/BTPopover";
import { cn } from "@btnet/utilities-core";

import {
    BTIconInfoCircleFilled,
    BTIconInfoCircleOutlined,
} from "commonComponents/btWrappers/BTIcon";

import "./Status.less";

import { type StatusTypes } from "./StatusDisplay";
import { statusTypeToDisplayType } from "./statusTypeToDisplayType";

export interface IStatusTagDisplayProps {
    statusType: StatusTypes;
    statusText: React.ReactNode;
    className?: string;
    popoverContent?: React.ReactNode;
    popoverPlacement?: TooltipPlacement;
    "data-testid"?: string;
    disablePopover?: boolean;
    disableIcon?: boolean;
    useBds?: boolean;
}

export class StatusTagDisplay extends PureComponent<IStatusTagDisplayProps> {
    render = () => {
        const { useBds, disablePopover, popoverContent, popoverPlacement, statusText } = this.props;
        const component = useBds ? (
            <BTStatusBadge
                testid={this.props["data-testid"] ?? "statusTag"}
                text={statusText as string}
                displayType={statusTypeToDisplayType(this.props.statusType)}
                textOnly={true}
            />
        ) : (
            <span
                className={cn("status-text", "badge", this.props.statusType, this.props.className)}
                data-testid={this.props["data-testid"]}
            >
                {statusText}
                {popoverContent && !disablePopover && !this.props.disableIcon && (
                    <>
                        <BTIconInfoCircleOutlined className="status-icon unfilled-icon" />
                        <BTIconInfoCircleFilled className="status-icon filled-icon" />
                    </>
                )}
            </span>
        );

        if (popoverContent) {
            return useBds ? (
                <div className="flex flex-row items-center">
                    {component}
                    <div className="p-1">
                        <BTPopover
                            disabled={disablePopover}
                            content={popoverContent}
                            mouseEnterDelay={0.3}
                            placement={popoverPlacement}
                        >
                            <IconInfoCircle size="md" />
                        </BTPopover>
                    </div>
                </div>
            ) : (
                <BTPopover
                    disabled={disablePopover}
                    content={popoverContent}
                    mouseEnterDelay={0.3}
                    placement={popoverPlacement}
                >
                    {component}
                </BTPopover>
            );
        }

        return component;
    };
}
